<div class="flex flex-col gap-8 public-standings">
  @for (group of standingsGroups; track group.groupId) {
    <div class="flex flex-col gap-4">
      <p class="group-name">{{ group.groupName }}</p>
      <p-table
        [value]="group.standings || []"
        [rows]="10"
        [loading]="loading"
        [style]="{ width: '100%' }"
        stripedRows
      >
        <ng-template #header>
          <tr>
            <th>{{ 'field.team' | translate }} </th>
            <th class="stats-col" [pTooltip]="'field.played' | translate" tooltipPosition="top">
              {{ 'field.played-abbr' | translate }}
            </th>
            <th class="stats-col" [pTooltip]="'field.won' | translate" tooltipPosition="top">
              {{ 'field.won-abbr' | translate }}
            </th>
            <th class="stats-col" [pTooltip]="'field.drawn' | translate" tooltipPosition="top">
              {{ 'field.drawn-abbr' | translate }}
            </th>
            <th class="stats-col" [pTooltip]="'field.lost' | translate" tooltipPosition="top">
              {{ 'field.lost-abbr' | translate }}
            </th>
            <th class="stats-col" [pTooltip]="'field.points' | translate" tooltipPosition="top">
              {{ 'field.points-abbr' | translate }}
            </th>
            <th class="last-matches-col">{{ 'field.lastMatches' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template #body let-standing>
          <tr>
            <td>{{ standing.teamName }}</td>
            <td class="stats-col">{{ standing.played }}</td>
            <td class="stats-col">{{ standing.won }}</td>
            <td class="stats-col">{{ standing.drawn }}</td>
            <td class="stats-col">{{ standing.lost }}</td>
            <td class="stats-col">{{ standing.points }}</td>
            <td class="last-matches-col">
              @for(status of standing.lastMatches; track $index) {
                @switch (status) {
                  @case ('WIN') {
                    <span class="pi pi-check win last-matches-icon"></span>
                  }
                  @case ('DRAW') {
                    <span class="pi pi-minus draw last-matches-icon"></span>
                  }
                  @case('LOST') {
                    <span class="pi pi-times last-matches-icon lost"></span>
                  }
                }
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
